<template>
    <div>
        <template v-for="day in days">
            <div>
                {{new Date(day.date)}}
            </div>
        </template>
    </div>
    
</template>

<script>
    export default {
        props: ['days'],
        name: "simple-weekly-schedule"
    }
</script>

<style scoped>

</style>